export default __webpack_public_path__ + "images/GG.a1f8080.png";